module.exports = __webpack_public_path__ + "static/media/anti-clockwise.0d8eb12b.svg";